<template>
    <div style="padding-right: 0px" class="col-sm-10">
      <div>
        <div
          v-if="showActionListLoader"
          style="
            margin: auto;
            display: block;
            margin-top: 10px;
            margin-bottom: 10px;
          "
          class="spinner-border"
        ></div>
        <div v-else>
            <!-- Edit -->
            <div v-if="isEdit" class="main_form_block">
              <div v-for="(actionToEdit, i) in actionsToShow" :key="i">
                <div class="form-group row col-md-12" style="padding-left:0px">
                  <div class="col-md-4" style="padding-right:0px" @click="stopMoving">
                    <multiselect
                      class="form-control multi-dropdown select_filter 
                      multiselect-overview"
                      v-model="actionToEdit['preSelectedAction']"
                      placeholder="Select Type"
                      label="name"
                      deselectLabel
                      selectedLabel
                      selectLabel
                      :options="actionTypeList"
                      track-by="name"
                      ref="multiselect"
                      :multiple="false"
                      :taggable="false"
                      openDirection="below"
                      @input="
                        setDefaultValue(
                          $event,
                          actionToEdit['preSelectedAction'],
                          i,
                          'edit'
                        );
                        resetNullValidation();
                      "
                      :disabled="false"
                    ></multiselect>
                  </div>

                  <div
                    class="col-md-4"
                    style="padding-right:0px"
                    v-if="
                      actionToEdit['preSelectedAction'].entity_type &&
                      actionToEdit['preSelectedAction'].entity_type == 'text'
                    "
                  >
                    <input
                      :disabled="true"
                      style="height: 93%"
                      :type="
                        computeTypeForEdit(actionToEdit['preSelectedAction'])
                      "
                      placeholder="Enter value"
                      v-model="actionToEdit['preSelectedValue']"
                      required="true"
                      class="form-control"
                      autocomplete="off"
                      @input="
                        checkNoValueChange($event);
                        resetNullValidation();
                      "
                      id="value"
                      :onkeydown="
                        computeTypeForEdit(actionToEdit['preSelectedAction']) ==
                        'number'
                          ? 'javascript: return event.keyCode == 69 ? false : true'
                          : ''
                      "
                    />
                  </div>
                  <div
                    class="col-md-4"
                    style="padding: 10px;padding-right:0px"
                    v-if="
                      actionToEdit['preSelectedAction'].entity_type &&
                      actionToEdit['preSelectedAction'].entity_type == 'boolean'
                    "
                  >
                    <toggle-button
                      style="margin-left: 6px"
                      v-model="actionToEdit['preSelectedValue']"
                      :sync="true"
                      @input="checkNoValueChange($event)"
                      :disabled="true"
                    />
                  </div>
                  <div
                    class="col-md-4 guardrail-tags"
                    style="padding-right:0px"

                    v-if="
                      actionToEdit['preSelectedAction'].entity_type &&
                      actionToEdit['preSelectedAction'].entity_type ==
                        'multiselect'
                    "
                    @click="stopMoving"
                  >
                    <multiselect
                      :disabled="false"
                      v-model="notificationEmailList"
                      :options="notificationEmailList"
                      :closeOnSelect="false"
                      :multiple="true"
                      :taggable="true"
                      label="name"
                      track-by="name"
                      @tag="
                        addNotification($event);
                        resetNullValidation();
                      "
                      @remove="isEmailListUpdated =true"
                      placeholder="Add Email"
                      tag-placeholder="Add Email"
                      class="form-control multi-dropdown select_filter"
                    >
                    </multiselect>
                  </div>
                  <div
                    class="del-icon-outer"
                    style="margin-top: 8px"
                    @click="removeSavedAction($event, actionToEdit, i)"
                  >
                    <span class="del-icon-inner">x</span>
                  </div>
                </div>
                <div
                  class="form-group row guardrail-tags"
                  v-if="
                    actionToEdit['preSelectedAction'] &&
                    actionToEdit['preSelectedAction'].name == 'Notification'
                  "
                >
                  <div class="col-md-4">
                    <multiselect
                      :disabled="true"
                      v-model="actionToEdit['template']"
                      :options="template_list"
                      :searchable="true"
                      ref="multiselect"
                      label="title"
                      track-by="title"
                      open-direction="bottom"
                      selectLabel
                      deselectLabel
                      selectedLabel
                      class="
                        form-control
                        multi-dropdown
                        col-md-12
                        select_filter
                      "
                      :multiple="false"
                      id="keywordTags"
                    >
                    </multiselect>
                  </div>
                  <div
                    v-if="
                      showPreviewLoader &&
                      actionToEdit['template'] &&
                      actionToEdit['template'].id
                    "
                    style="
                      margin: auto;
                      display: block;
                      margin-top: 10px;
                      margin-bottom: 10px;
                    "
                    class="spinner-border"
                  ></div>
                  <div
                    v-else-if="
                      actionToEdit['template'] && actionToEdit['template'].id
                    "
                    class="col-md-2"
                    style="margin-top: 8px;padding-left:0px"
                  >
                    <div
                      class="del-icon-outer"
                      style="margin-left: 2px;width:73px"
                      @click="showPreview(actionToEdit['template'].id)"
                    >
                      <span class="del-icon-inner"> Preview </span>
                    </div>
                  </div>

                  <div class="col-md-3"></div>
                  <!-- <div
                    class="del-icon-outer"
                    style="margin-top: 8px"
                    v-if="
                      !(
                        showPreviewLoader &&
                        actionToEdit['template'] &&
                        actionToEdit['template'].id
                      )
                    "
                  >
                    <span class="del-icon-inner">x</span>
                  </div> -->
                </div>
              </div>
            </div>

          <!-- Add -->
          <template v-if="actionTypeList && actionTypeList.length">
            <div
              style="margin-bottom: 15px"
              v-for="(item, index) in afterfilledActions"
              :key="'afterfilledActions_1_' + index"
              class="main_form_block"
            >
              <div class="form-group row col-md-12" style="padding-left:0px">
                <div class="col-md-4" style="padding-right:0px" @click="stopMoving">
                  <multiselect
                    class="
                      form-control
                      multi-dropdown
                      select_filter
                      multiselect-overview
                    "
                    v-model="selectedAction[index]"
                    placeholder="Select Type"
                    label="name"
                    deselectLabel
                    selectedLabel
                    openDirection="below"
                    selectLabel
                    :disabled="disableTheSelected[index]"
                    :options="actionTypeList"
                    track-by="action_id"
                    ref="multiselect"
                    @input="
                      setDefaultValue($event, selectedAction[index], index);
                      resetNullValidation();
                    "
                    :multiple="false"
                    :taggable="false"
                  ></multiselect>
                </div>
                <div
                  v-if="
                    selectedAction[index] &&
                    (selectedAction[index].entity_data_type
                      ? selectedAction[index].entity_data_type == 'text'
                        ? true
                        : false
                      : false)
                  "
                  class="col-md-4"
                  style="padding-right:0px"
                >
                  <input
                    :type="computeTypeForAdd(selectedAction[index])"
                    placeholder="Enter value"
                    required="true"
                    autocomplete="off"
                    v-model="selectedValue[index]"
                    class="form-control input-overview"
                    @input="
                      checkNoValueChange($event);
                      resetNullValidation();
                    "
                    id="value"
                    :onkeydown="
                      computeTypeForAdd(selectedAction[index]) == 'number'
                        ? 'javascript: return event.keyCode == 69 ? false : true'
                        : ''
                    "
                  />
                </div>
                <div
                  v-if="
                    selectedAction[index] &&
                    (selectedAction[index].entity_data_type
                      ? selectedAction[index].entity_data_type == 'multiselect'
                        ? true
                        : false
                      : false)
                  "
                  class="col-md-4 guardrail-tags"
                  style="padding-right:0px"
                  @click="stopMoving"
                >
                  <multiselect
                    v-model="selectedValue[index]"
                    :options="selectedNotificationValue"
                    :closeOnSelect="false"
                    :multiple="true"
                    :taggable="true"
                    label="name"
                    track-by="name"
                    @tag="
                      addNotification($event, index);
                      resetNullValidation();
                    "
                    placeholder="Add Email"
                    tag-placeholder="Add Email"
                    class="
                      form-control
                      multi-dropdown
                      select_filter
                      multiselect-overview
                    "
                    :options-limit="300"
                    :limit="3"
                    :limit-text="limitText"
                    tagPosition="bottom"
                  >
                  </multiselect>
                </div>
                <div
                  v-if="
                    selectedAction[index] &&
                    (selectedAction[index].entity_data_type
                      ? selectedAction[index].entity_data_type == 'singleselect'
                        ? true
                        : false
                      : false)
                  "
                  class="col-md-4 guardrail-tags"
                  style="padding-right:0px"
                  @click="stopMoving"
                >
                  <multiselect
                    v-model="selectedValue[index]"
                    :options="selectedNotificationValue"
                    :closeOnSelect="false"
                    :multiple="false"
                    :taggable="true"
                    label="name"
                    track-by="name"
                    @tag="
                      addNotification($event, index);
                      resetNullValidation();
                    "
                    placeholder="Add Email"
                    tag-placeholder="Add Email"
                    class="
                      form-control
                      multi-dropdown
                      select_filter
                      multiselect-overview
                    "
                    :options-limit="300"
                    :limit="3"
                    :limit-text="limitText"
                    tagPosition="bottom"
                  >
                  </multiselect>
                </div>

                <div
                  v-if="
                    selectedAction[index] &&
                    (selectedAction[index].entity_data_type
                      ? selectedAction[index].entity_data_type == 'boolean'
                        ? true
                        : false
                      : false)
                  "
                  class="col-md-4"
                  style="padding-right:0px;padding:10px"
                >
                  <toggle-button
                    style="margin-left: 6px"
                    v-model="selectedValue[index]"
                    @input="checkNoValueChange($event)"
                  />
                </div>
                <div
                  v-if="
                    afterfilledActions.length !=
                      oldActionTypeList.length - actions.length &&
                    index == afterfilledActions.length - 1 &&
                    selectedAction[index] != null &&
                    selectedValue[index] !== '' &&
                    actionTypeList.length > 0
                  "
                  style="margin-top: 8px"
                  @click="
                    addAction($event, index);
                    resetNullValidation();
                  "
                  id="submit"
                  class="del-icon-outer"
                >
                  <span class="del-icon-inner"
                    ><i class="fa fa-plus fa-xs"></i
                  ></span>
                </div>
                <div
                  v-if="selectedAction[index]!=null&&selectedValue[index]!==''"
                  @click="
                    removeAction($event, selectedAction[index], index);
                    resetNullValidation();
                  "
                  id="submit"
                  class="del-icon-outer"
                  style="margin-top: 8px"
                >
                  <span class="del-icon-inner">x</span>
                </div>
              </div>

              <div
                class="form-group row col-md-12 guardrail-tags"
                style="padding-left:0px"
                v-if="
                  selectedAction[index] &&
                  selectedAction[index].name == 'Notification'
                "
              >
                <!-- //hide select template read only label -->
                <!-- <div class="col-md-5">
                    <input
                      type="text"
                      placeholder="Select Template"
                      value="Select Template"
                      required="true"
                      class="form-control custom-placeholder input-overview"
                      id="dailyBudget"
                      :disabled='true'
                    />
                  </div> -->
                <div class="col-md-4" style="padding-right:0px">
                  <multiselect
                    v-model="template"
                    :options="template_list"
                    :searchable="true"
                    ref="multiselect"
                    label="title"
                    track-by="title"
                    open-direction="bottom"
                    placeholder="Select Template"
                    selectLabel
                    deselectLabel
                    selectedLabel
                    class="
                      form-control
                      multi-dropdown
                      col-md-12
                      select_filter
                      multiselect-overview
                    "
                    :multiple="false"
                    id="keywordTags"
                  >
                  </multiselect>
                </div>
                  <div
                    v-if="
                      showPreviewLoader &&
                      template &&
                      template.id
                    "
                    style="
                      margin: auto;
                      display: block;
                      margin-top: 10px;
                      margin-bottom: 10px;
                    "
                    class="spinner-border "
                  ></div>
                  <div
                    v-else-if="
                      template &&
                      template.id
                    "
                    style="margin-top: 8px;"
                    class="col-md-2"
                  >
                    <div
                      class="del-icon-outer"
                      style="margin-left: 2px;width:73px"
                      @click="showPreview(template.id)"
                    >
                      <span class="del-icon-inner"> Preview </span>
                    </div>
                  </div>
              </div>
            </div>
          </template>
          <span v-if="nullPresent" class="no-data-style mr-1 ml-1"
            >Provide all fields to proceed.</span
          >
        </div>
      </div>
      <span v-if="cannotEdit" style="padding: 20px" class="no-data-style"
        >Max budget should be greater then min budget</span
      >
      <div
        style="display: flex; justify-content: center; background-color: white"
      >
        <div
          v-if="showNewLoader"
          style="
            margin: auto;
            display: block;
            margin-top: 10px;
            margin-bottom: 10px;
          "
          class="spinner-border"
        ></div>
      </div>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";

export default {
  name: "AddEditGuardrailActionAutomation",
  components: {
    Multiselect,
  },
  data() {
    return {
      actionsToDelete: [],

      showActionListLoader: true,
      flag: false,
      actionTypeList: [],
      disableTheSelected: [],
      editAutomationId: "",
      associateAutomationId: "",
      automationTarget: "",
      selectedAutomation: {},
      selectedAction: [],
      preSelectedAction: "",
      selectedValue: [],
      preSelectedValue: "",
      prefilledActions: [],
      afterfilledActions: [],
      updatedActionData: [],
      sendNotification: false,
      emailList: [],
      actionValueList: [[]],
      editActionValueList: [],
      showLoader: false,
      showNewLoader: false,
      selectedNotificationValue: [],
      cannotEdit: false,
      template_list: [],
      template: null,
      showPreviewLoader: false,
      nullPresent: false,
      notificationEmailList:[],
      isEmailListUpdated : false
    };
  },
  props: [
    "currentIndex",
    "automationList",
    "actions",
    "targetValue",
    "actionsToShow",
    "initialActionsSaved",
  ],
  computed: {
    isEdit: {
      get() {
        return true || this.$store.state.isEdit;
      },
    },
    oldActionTypeList: {
      get() {
        return this.$store.state.automation.actionTypeList;
      },
    },
  },
  mounted() {
    let vm = this;
    let target = JSON.parse(this.targetValue).name;
    this.automationTarget = target;
    this.$store
      .dispatch("automation/getActionTypeList", { type: target })
      .then((res) => {
        vm.$emit("setHoverSelected", true);
        vm.flag = true;
        vm.actionTypeList = vm.oldActionTypeList;
        if (vm.actions) {
          vm.actions.forEach((action, index) => {
            vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
              return obj.action_id != action.action_id;
            });
          });
        }
        if (vm.isEdit == true) {
          // vm.setPreSelectedAction();

          //actions to just show on ui
          if (this.actionsToShow && this.actionsToShow.length) {
            this.actionsToShow.map((actionToEdit) => {
              actionToEdit["preSelectedAction"] = {
                action_id: actionToEdit.action_id,
                name: actionToEdit.title,
                entity_type: actionToEdit.entity_type,
                entity_data_type: actionToEdit.entity,
                action_type: actionToEdit.action_type,
              };
              //code added to support edit in email list during edit 
              if(actionToEdit.action_value=="Notification"){
                vm.notificationEmailList = vm.notificationEmailList.concat(JSON.parse(actionToEdit.value))
                vm.selectedNotificationValue = vm.selectedNotificationValue.concat(JSON.parse(actionToEdit.value))
              }
              if (actionToEdit.entity_type == "boolean") {
                actionToEdit["preSelectedValue"] = JSON.parse(
                  actionToEdit.value
                );
              } else if (actionToEdit.entity_type == "multiselect") {
                actionToEdit["preSelectedValue"] = JSON.parse(
                  actionToEdit.value
                );
              } else {
                actionToEdit["preSelectedValue"] = actionToEdit.value;
              }
              // update template code here
              if (
                actionToEdit["template_name"] &&
                actionToEdit["template_id"]
              ) {
                actionToEdit["template"] = {
                  id: actionToEdit.template_id,
                  title: actionToEdit.template_name,
                };
              }
            });
          }
        }
        // else
        {
          vm.selectedAutomation = vm.automationList[vm.currentIndex];
          vm.afterfilledActions.push({
            list1: vm.actionTypeList,
            list2: vm.actionValueList,
          });
        }
        vm.changeTriggerDropDown(vm.currentIndex);
        vm.showActionListLoader = false;
      });

    let listData = target == "Campaign Group" ? "CampaignGroup" : target;

    this.$store
      .dispatch("template/getTemplateList", { type: listData })
      .then((res) => {
        vm.template_list = res;
      });
  },
  watch: {
    notificationEmailList(){
      debugger
      if(this.notificationEmailList.length==0){
        let index = this.actionsToShow.map(x=>x.title).indexOf("Notification");
        let e = 'filler_value'
        this.removeSavedAction(e,this.actionsToShow[index],index);
      }
    },
    sendNotification() {
      if (this.sendNotification) {
        this.addEmail();
      } else {
        this.emailList = [];
      }
    },
    currentIndex() {
      this.changeTriggerDropDown(this.currentIndex);
    },
    selectedAction(){
      if(this.selectedAction && this.selectedAction.length && (this.automationId==""||this.automationId=='null'|| !this.automationId)){
        this.$emit("actionExistInCreate",true)
      }
      else if(this.automationId==""||this.automationId=='null'|| !this.automationId|| !this.automationId){
        this.$emit("actionExistInCreate",false)
      }
    }
  },
  methods: {
    setPreSelectedAction() {
      const vm = this;
      vm.preSelectedAction = {
        action_id: vm.actionToEdit.action_id,
        name: vm.actionToEdit.title,
        entity_type: vm.actionToEdit.entity_type,
        action_type: vm.actionToEdit.action_type,
      };

      if (vm.actionToEdit.entity_type == "boolean") {
        vm.preSelectedValue = JSON.parse(this.actionToEdit.value);
      } else if (vm.actionToEdit.entity_type == "multiselect") {
        vm.preSelectedValue = JSON.parse(vm.actionToEdit.value);
      } else {
        vm.preSelectedValue = vm.actionToEdit.value;
      }

      if (vm.actionToEdit.template_name && vm.actionToEdit.template_id) {
        vm.template = {
          id: vm.actionToEdit.template_id,
          title: vm.actionToEdit.template_name,
        };
      }
    },
    resetNullValidation() {
      this.nullPresent = false;
    },
    computeTypeForEdit(action) {
      let type = "text";
      if (action) {
        type =
          (action.name || "").trim() == "Min Budget" ||
          (action.name || "").trim() == "Max Budget" ||
          (action.name || "").trim() == "DecreaseACOS"
            ? "number"
            : "text";
      }
      return type;
    },
    computeTypeForAdd(action) {
      let type = "text";
      if (action) {
        type =
          (action.name || "").trim() == "Min Budget" ||
          (action.name || "").trim() == "Max Budget" ||
          (action.name || "").trim() == "DecreaseACOS"
            ? "number"
            : "text";
      }
      return type;
    },
    removeSavedAction(e, actionToEdit, index) {
      debugger
      var selectedValue = actionToEdit["preSelectedAction"];
      this.actionsToDelete.push({ id: actionToEdit["id"], type: "action" });
      this.actionsToShow.splice(index, 1);
      if (selectedValue) {
        var duplicate = false;
        for (var i = 0; i < this.actionTypeList.length; i++) {
          if (this.actionTypeList[i].name == selectedValue.name) {
            duplicate = true;
            break;
          }
        }
        if (!duplicate) {
          selectedValue["entity_data_type"] = selectedValue["entity_type"];
          this.actionTypeList.push(selectedValue);
        }
      }
      // this.disableTheSelected.pop();
      if (this.afterfilledActions.length < 1) {
        this.afterfilledActions.push({
          list1: this.actionTypeList,
          list2: this.actionValueList,
        });
      }
    },
    removeAction(e, selectedValue, index) {
      //e.stopPropagation();
      this.$emit("setHoverSelected", true);
      this.afterfilledActions.splice(index, 1);
      this.updatedActionData.splice(index, 1);
      this.selectedAction.splice(index, 1);
      this.selectedValue.splice(index, 1);
      if (selectedValue) {
        var duplicate = false;
        for (var i = 0; i < this.actionTypeList.length; i++) {
          if (this.actionTypeList[i].name == selectedValue.name) {
            duplicate = true;
            break;
          }
        }
        if (!duplicate) {
          this.actionTypeList.push(selectedValue);
        }
      }
      this.disableTheSelected.pop();
      if (this.afterfilledActions.length < 1) {
        this.afterfilledActions.push({
          list1: this.actionTypeList,
          list2: this.actionValueList,
        });
      }
    },
    stopMoving(e) {
      e.stopPropagation();
    },
    checkNoValueChange(e) {
      this.$emit("setHoverSelected", true);
      this.cannotEdit = false;
      if (
        this.preSelectedAction &&
        this.preSelectedAction.name.trim() == "Min Budget"
      ) {
        let isMax = this.actions.find((e) => e.title.trim() == "Max Budget");
        if (isMax) {
          if (parseInt(isMax.value) < parseInt(this.preSelectedValue)) {
            this.cannotEdit = true;
          }
        }
      }

      if (
        this.preSelectedAction &&
        this.preSelectedAction.name.trim() == "Max Budget"
      ) {
        let isMin = this.actions.find((e) => e.title.trim() == "Min Budget");
        if (isMin) {
          if (parseInt(isMin.value) > parseInt(this.preSelectedValue)) {
            this.cannotEdit = true;
          }
        }
      }

      if (this.actions && this.actions.length) {
        var isMax = this.actions.find((e) => e.title.trim() == "Max Budget");
        var isMin = this.actions.find((e) => e.title.trim() == "Min Budget");
        var newMax = -1;
        var newMin = -1;
        newMax = this.selectedAction.findIndex(
          (e) => e.name.trim() == "Max Budget"
        );
        newMin = this.selectedAction.findIndex(
          (e) => e.name.trim() == "Min Budget"
        );

        if (isMax && newMin != -1) {
          if (parseInt(isMax.value) < parseInt(this.selectedValue[newMin])) {
            this.cannotEdit = true;
          }
        }
        if (isMin && newMax != -1) {
          if (parseInt(isMin.value) > parseInt(this.selectedValue[newMax])) {
            this.cannotEdit = true;
          }
        }
      }

      // if(this.selectedAction && this.selectedAction.length){
      // 	let isMin = this.selectedAction.find((e) => e.action_name.trim() == 'Min Budget')
      // 	let isMax = this.updatedActionData.find((e) => e.action_name.trim() == 'Max Budget')
      // 	if(isMin && isMax){
      // 		if(parseInt(isMin.name)>parseInt(insMax.name)){
      // 			this.cannotEdit = true
      // 		}
      // 	}
      //
      // }				//e.stopPropagation();
    },
    addNotification(value, index) {
      //	e.stopPropagation();
      let isComma = value.includes(",");
      debugger
      this.$emit("setHoverSelected", true);
      if (index != undefined) {
        let arr = this.selectedValue[index].length
          ? this.selectedValue[index]
          : [];
        if (isComma) {
          let data = value.split(",");
          data.map((value) => {
            arr.push({ name: value });
          });
        } else {
          arr.push({ name: value });
        }
        this.selectedValue[index] = arr;
        this.selectedNotificationValue = arr;
      } else {
        let arr = [...this.preSelectedValue];
        if (isComma) {
          let data = value.split(",");
          data.map((value) => {
            arr.push({ name: value });
          });
        } else {
          arr.push({ name: value });
        }
        //	arr.push({name:value})
        debugger
        this.preSelectedValue = arr;
        this.isEmailListUpdated = true;
        this.notificationEmailList.push({name:value});
        this.selectedNotificationValue.push({name:value})
      }
    },
    stopClose(e) {
      e.stopPropagation();
    },
    setDefaultValue(e, entity, index, type) {
      this.$emit("setHoverSelected", true);
      //	e.stopPropagation();
      if (type == "edit") {
        this.actionsToShow;
        this.preSelectedValue = "";
        this.preSelectedAction.entity_type = entity.entity_data_type;
        if (entity ? entity.entity_data_type == "boolean" : false) {
          this.preSelectedValue = false;
        }
        if (e.name == "Notification") {
          this.template = null;
        }
      } else {
        this.selectedValue[index] = "";
        if (entity ? entity.entity_data_type == "boolean" : false) {
          this.selectedValue[index] = false;
        }
        if (e.name == "Notification") {
          this.template = null;
        }
      }
    },
    removePreAction(selectedValue, index) {
      this.prefilledActions.splice(index, 1);
      this.preSelectedAction.splice(index, 1);
      this.preSelectedValue.splice(index, 1);
    },

    addEmail() {
      this.$emit("setHoverSelected", true);
      if (this.emailList.length < 3) {
        this.emailList.push("");
      }
    },
    changeTriggerDropDown(index) {
      this.$emit("setHoverSelected", true);
      if (this.currentIndex != index) {
        this.flag = true;
        this.actionTypeList = this.oldActionTypeList;
        this.$emit("updateCurrentIndex", index);
        this.prefilledActions = [];
        this.afterfilledActions = [];
        let vm = this;
        if (
          this.automationList[index].actions == undefined ||
          this.automationList[index].actions.length == 0
        ) {
          this.selectedAutomation = this.automationList[index];
          this.afterfilledActions.push({
            list1: this.actionTypeList,
            list2: this.actionValueList,
          });
        } else {
          this.selectedAutomation = this.automationList[index];

          this.selectedAutomation.actions.forEach((action, index2) => {
            vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
              return obj.action_id != action.action_id;
            });
            var defaultAction = {};
            defaultAction.action_id =
              vm.selectedAutomation.actions[index2].action_id;
            defaultAction.name = vm.selectedAutomation.actions[index2].title;
            var defaultValue = {};
            defaultValue.action_id =
              vm.selectedAutomation.actions[index2].action_id;
            defaultValue.name = vm.selectedAutomation.actions[index2].value;
            vm.preSelectedAction[index2] = defaultAction;
            vm.preSelectedValue[index2] = defaultValue;
            vm.prefilledActions.push({
              list1: [
                {
                  action_id: action.action_id,
                  name: action.title,
                },
              ],
              list2: [
                {
                  action_id: action.action_id,
                  name: action.value,
                },
              ],
            });
          });
        }
      }
    },
    addAction(e, index) {
      //	e.stopPropagation();
      this.$emit("setHoverSelected", true);
      this.flag = false;
      let vm = this;
      if (
        this.selectedAction[index] != null &&
        this.selectedValue[index] !== ""
      ) {
        this.updatedActionData.push({
          action_id: this.selectedAction[index].action_id,
          name: this.selectedValue[index],
          action_name: this.selectedAction[index].name,
          entity_type: this.selectedAction[index].entity_data_type,
          action_type: this.selectedAction[index].action_type,
        });
        vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
          return obj.action_id != vm.selectedAction[index].action_id;
        });
        this.disableTheSelected.push(true);
      }
      this.updatedActionData.forEach((action) => {
        vm.actionTypeList = vm.actionTypeList.filter(function (obj) {
          return obj.action_id != action.action_id;
        });
      });
      this.afterfilledActions.push({
        list1: this.actionTypeList,
      });
    },
    callToggleModal(e) {
      // this.$emit("toggleModal");
      // this.$emit("enableOther")
    },
    limitText(count) {
      return ` and ${count} more...`;
    },
    ifNullExist() {
      if (false && this.isEdit) {
        //bypass validation for empty in edit case for now
        return false
        if (
          !this.preSelectedAction ||
          !this.preSelectedAction.action_id ||
          !this.preSelectedValue.toString().trim()
        ) {
          return true;
        }
      } else {
        var emptyAction = this.selectedAction.filter((item) => {
          if (!item || !item.action_id) {
            return true;
          }
        });
        var emptyValue = this.selectedValue.filter((item) => {
          if (!item.toString().trim()) {
            return true;
          }
        });
        if((emptyAction && emptyAction.length)||(emptyValue && emptyValue.length)){
          return true
        }
        // if (
        //   this.selectedAction.length < 1 ||
        //   this.selectedValue.length < 1 ||
        //   this.selectedAction.length != this.selectedValue.length
        // ) {
        //   return true;
        // }
        // if (emptyAction.length || emptyValue.length) {
        //   return true;
        // } 
        // else 
        {
          return false;
        }
      }
    },
    submitAction(autoId) {
      console.log('AddEditGuardrailActionAutomation - submitAction')
      //   e.stopPropagation();
      // this.$emit("setHoverSelected", true);
      let vm = this;
      this.nullPresent = false;
      if (this.ifNullExist()) {
        this.nullPresent = true;
        return true;
      }
      let notificationAction = this.actions.filter(x=>x.title=="Notification").length? this.actions.filter(x=>x.title=="Notification")[0]:{};
      if (!this.cannotEdit) {
        let deltPromises = [];
        debugger
        if(this.isEmailListUpdated && Object.keys(notificationAction).length){
          this.actionsToDelete.push({
            id:notificationAction.id,
            type: "action"
          })
        }
        this.actionsToDelete.forEach((delAction) => {
          deltPromises.push(
            this.$store.dispatch("automation/DelAction", delAction)
          );
        });
        Promise.all(deltPromises).then((ress) => {
          // if (false && this.isEdit == true) {
          //   var actionData = {
          //     action_id: this.preSelectedAction.action_id,
          //     action_value: this.preSelectedAction.name,
          //     value:
          //       this.preSelectedAction.entity_type == "multiselect"
          //         ? JSON.stringify(this.preSelectedValue)
          //         : this.preSelectedValue,
          //     automation_id: this.actionToEdit.automation_id,
          //     id: this.actionToEdit.id,
          //     entity_type: this.preSelectedAction.entity_type,
          //     action_type: this.preSelectedAction.action_type,
          //   };

          //   if (this.template) {
          //     actionData.template = this.template;
          //   }

          //   actionData.target =
          //     this.automationTarget == "Campaign Group"
          //       ? "CampaignGroup"
          //       : this.automationTarget;

          //   this.showNewLoader = true;
          //   this.$store
          //     .dispatch("automation/editAction", actionData)
          //     .then((resposne) => {
          //       vm.showNewLoader = false;
          //       vm.callToggleModal();
          //       var data = {
          //         actionData: resposne.data,
          //         ind: vm.currentIndex,
          //         isEdit: true,
          //       };
          //       // vm.$emit("updateAutomationList", data);
          //     });
          // }
          // else
          {
            var actionData = {
              action: [],
              sendNotification: "",
              email: [],
              automationId: "",
              entity_type: "",
              action_type: "",
            };
            if (
              vm.updatedActionData.length ==
              vm.afterfilledActions.length - 1
            ) {
              const index = vm.updatedActionData.length;
              if (
                vm.selectedAction[index] != null &&
                vm.selectedValue[index] !== ""
              ) {
                vm.updatedActionData.push({
                  action_id: vm.selectedAction[index].action_id,
                  name: vm.selectedValue[index],
                  action_name: vm.selectedAction[index].name,
                  entity_type: vm.selectedAction[index].entity_data_type,
                  action_type: vm.selectedAction[index].action_type,
                });
              }
            }

            vm.updatedActionData = vm.updatedActionData.map((res, i) => {
              res.name = vm.selectedValue[i];
              return res;
            });

            vm.updatedActionData.forEach((action) => {
              actionData.action.push({
                id: action.action_id,
                value:
                  action.entity_type == "multiselect"
                    ? JSON.stringify(action.name)
                    : action.name,
                action_value: action.action_name,
                entity_type: action.entity_type,
                action_type: action.action_type,
              });
            });
            if(this.automationList && this.automationList.length && this.automationList[0]["id"]){
              actionData.automationId = this.automationList[0]["id"]
            }
            else{
             actionData.automationId = autoId;
            }
            debugger
            
            if(vm.isEmailListUpdated && Object.keys(notificationAction).length ){
              debugger
              actionData.action.push({
                id : notificationAction.action_id,
                value : JSON.stringify(vm.notificationEmailList),
                action_value: notificationAction.title,
                entity_type: notificationAction.entity_type,
                action_type: notificationAction.action_type
              })
            }
            actionData.action.forEach((res, index) => {
              if (res.action_value == "Notification") {
                actionData.action[index].template = this.template;
              }
            });

            actionData.target =
              this.automationTarget == "Campaign Group"
                ? "CampaignGroup"
                : this.automationTarget;

            if (vm.validate(vm.updatedActionData)) {
              vm.showNewLoader = true;
              if(actionData && actionData.action && actionData.action.length){
                vm.$store
                  .dispatch("automation/updateAutomation", actionData)
                  .then((resposne) => {
                    vm.showNewLoader = false;
                    vm.callToggleModal();
                    var data = {
                      actionData: resposne.data,
                      ind: vm.currentIndex,
                      isEdit: false,
                    };

                    vm.$emit("actionsAdded");
                  });
              }
              else{
                vm.showNewLoader = false;
                vm.callToggleModal();
                vm.$emit("actionsAdded");
              }
            }
          }
        });
      }
    },
    validate(data) {
      if (data && data.length) {
        let isMin = data.find((e) => e.action_name.trim() == "Min Budget");
        let isMax = data.find((e) => e.action_name.trim() == "Max Budget");
        if (isMin && isMax) {
          if (parseInt(isMin.name) > parseInt(isMax.name)) {
            this.cannotEdit = true;
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    showPreview(tempId) {
      let payload = {
        id: tempId,
      };
      let vm = this;
      this.showPreviewLoader = true;
      this.$store.dispatch("template/getTemplate", payload).then((res) => {
        vm.showPreviewLoader = false;
        this.$emit("openPreviewPopUp", res);
      });
    },
  },
};
</script>
<style lang="scss" media="screen">
.col-md-12.row.active {
  background: #f7f7f7;
  border-right: 4px solid #ddd !important;
}
.scrollbar {
  float: left;
  height: 100vh;
  overflow: auto;
  background: #fff;
  overflow-y: scroll;
  margin-bottom: 25px;
}
.scrollbar-primary::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
}
.popover-custom-wraps {
  width: 100%;
  min-width: 800px;
  background: #d4d4d4;
  padding: 2px;
  border-radius: 5px;
}
.popover-custom-wraps {
  .multiselect__tags-wrap {
    max-width: 290px;
  }
}
.popover-custom-wraps .multiselect__input,
.multiselect__single {
  display: block;
  overflow: hidden;
}
.popover-custom-wraps {
  .multiselect__tags-wrap {
    display: inline-grid;
  }
}
.popover-custom-wraps {
  .multiselect__strong {
    display: block;
  }
}
.arrow-up {
  width: 0;
  height: 12px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #d4d4d4;
}

.guardrail-tags {
  .multiselect__tag {
    text-transform: none !important;
  }
}
.guardrail-tags {
  .multiselect__single {
    text-transform: none !important;
    overflow: hidden;
  }
}
.guardrail-tags {
  .multiselect__option span {
    text-transform: none !important;
  }
}
</style>
